export default __webpack_public_path__ + "static/media/vpn-background-2.9ac42244.png";